import React from 'react';
import FormControl from '@mui/material/FormControl';
import { FormControlProps } from '@mui/material/FormControl/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { OutlinedInputProps } from '@mui/material/OutlinedInput/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import { CustomChangeEvent, CustomFocusEvent } from '../../../@types/helper';

export interface ITextInputProps {
    label : string | number;
    name : string;
    id ?: string;
    formControlProps ?: FormControlProps;
    inputProps ?: OutlinedInputProps;
    onChange ?: (e : CustomChangeEvent) => void;
    onBlur ?: (e : CustomFocusEvent) => void;
    className ?: string;
    type ?: string;
    contentEditable ?: boolean;
    disabled ?: boolean;
    hasError ?: boolean;
    error ?: string;
    placeholder ?: string;
    value : string | number;
    selectOnFocus ?: boolean;
    startAdornment ?: React.ReactNode;
    endAdornment ?: React.ReactNode;
    multiline ?: boolean;
    rows ?: number;
    transparentBackground ?: boolean;
    autoFocus ?: boolean;
}

const TextInput = (props : ITextInputProps) : React.ReactElement => {

    const onChange = (e : CustomChangeEvent) : void => {
        if (props.onChange) {
            props.onChange(e);
        }
    };

    const onBlur = (e : CustomFocusEvent) : void => {
        if (props.onBlur) props.onBlur(e);
    };

    const handleFocus = (e : React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) : void => {
        if (props.selectOnFocus)
            e.currentTarget.select();
    };

    const {
        formControlProps,
        label,
        className,
        type,
        contentEditable,
        disabled,
        hasError,
        error,
        id,
        name,
        placeholder,
        value,
        multiline = false,
        rows = 1,
        transparentBackground = true,
    } = props;

    return (
        <div className={`pl10 pr10 fdc ais jcfs ${className || ''}`}>
            <FormControl error={hasError} disabled={disabled} variant={'standard'} className={'flx1 m0'} {...formControlProps}>
                {label && <InputLabel htmlFor={name} className={`${transparentBackground ? '' : 'bcw'}`}>{label}</InputLabel>}
                <Input
                    error={!!error}
                    id={id ?? name}
                    type={type}
                    className={`${transparentBackground ? '' : 'bcw'}`}
                    multiline={multiline}
                    rows={rows}
                    disabled={disabled}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onFocus={handleFocus}
                    contentEditable={contentEditable}
                    fullWidth
                    placeholder={placeholder}
                    {...props.inputProps}
                    startAdornment={props.startAdornment}
                    endAdornment={props.endAdornment}
                    autoFocus={props.autoFocus}
                    autoComplete={''}
                />
                <FormHelperText error>{error || ''}</FormHelperText>
            </FormControl>
        </div>
    );
};

export default TextInput;
